<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return{
      testList:[]
    }
  },
  components: {

  },
  computed:{
      userInfo() {
        return this.$store.state.userInfo;
      },
  },
  mounted(){

  }
}
</script>

<style>

#app{
  height: 100%;
  width: 100%;
}

/* 1. 整个滚动条本体 */
::-webkit-scrollbar {
  width: 4px;            /* 纵向滚动条宽度 */
  height: 4px;  /* 横向滚动条高度 ← 补上这句 */
  background: transparent;/* 轨道背景 */
}

/* 2. 滑块（thumb） */
::-webkit-scrollbar-thumb {
  background: #3f4457;
  border-radius: 6px;
}

/* 3. 轨道（track） */
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0);
  border-radius: 6px;
}



</style>
